import { useMutation, useSuspenseQuery } from "@tanstack/react-query";
import { toast } from "sonner";
import { useResourceScope } from "@/lib/resource-context";
import { assignOrgMemberRole } from "./assign-org-member-role";
import { orgMembersQueryOptions } from "./get-org-members";
import { orgMembersKeys } from "./query-keys";
import { removeOrgMember } from "./remove-org-member";

export const useGetOrgMembers = () => {
  const { organizationId } = useResourceScope();
  return useSuspenseQuery(orgMembersQueryOptions(organizationId));
};

export const useAssignOrgMemberRole = () => {
  const { organizationId } = useResourceScope();
  return useMutation({
    mutationFn: ({ accountId, role }: { accountId: string; role: string }) =>
      assignOrgMemberRole({ organizationId, accountId, role }),
    meta: {
      invalidates: [orgMembersKeys.list(organizationId)],
      errorMessage: "Failed to change role",
    },
    onSuccess: () => {
      toast.success("Role updated successfully");
    },
  });
};

export const useRemoveOrgMember = () => {
  const { organizationId } = useResourceScope();
  return useMutation({
    mutationFn: ({ accountId }: { accountId: string }) =>
      removeOrgMember({ organizationId, accountId }),
    meta: {
      invalidates: [orgMembersKeys.list(organizationId)],
      errorMessage: "Failed to remove member",
    },
    onSuccess: () => {
      toast.success("Member removed successfully");
    },
  });
};
